/**
 * Free Shipping Progress Bar
 * Automatically updates when cart quantities change or items are removed
 */

class FreeShippingProgressBar extends HTMLElement {
  constructor() {
    super();
    this.threshold = 12500; // $125.00 in cents
    this.cartUpdateUnsubscriber = undefined;
  }

  connectedCallback() {
    // Subscribe to cart update events
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      this.updateProgressBar(event.cartData);
    });
  }

  disconnectedCallback() {
    // Clean up subscription when element is removed
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  updateProgressBar(cartData) {
    // Get the current cart total in cents
    const currentTotal = cartData.total_price || 0;

    // Calculate percentage (capped at 100%)
    const percentage = Math.min((currentTotal / this.threshold) * 100, 100);

    // Find the progress bar and text elements
    const progressBar = this.querySelector('.progress-bar__fill');
    const messageElement = this.querySelector('.progress-bar__message');
    const amountElement = this.querySelector('.progress-bar__amount');
    const container = this.querySelector('.free-shipping-progress-bar');

    if (!progressBar || !container) return;

    // Update progress bar width
    progressBar.style.width = `${percentage}%`;

    // Update message based on whether threshold is met
    if (currentTotal >= this.threshold) {
      // Threshold reached - show success message
      if (messageElement) {
        messageElement.textContent = '🎉 Congrats! You\'ve unlocked';
      }
      if (amountElement) {
        amountElement.textContent = 'FREE SHIPPING!';
      }
      container.classList.add('progress-bar--complete');
      container.classList.remove('progress-bar--incomplete');
    } else {
      // Still working toward threshold
      const remaining = this.threshold - currentTotal;
      const remainingFormatted = this.formatMoney(remaining);

      if (messageElement) {
        messageElement.textContent = '🚚 You\'re only';
      }
      if (amountElement) {
        amountElement.textContent = `${remainingFormatted} away from FREE SHIPPING!`;
      }
      container.classList.add('progress-bar--incomplete');
      container.classList.remove('progress-bar--complete');
    }
  }

  formatMoney(cents) {
    // Format cents as currency (e.g., 2000 -> $20.00)
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }
}

// Register the custom element
customElements.define('free-shipping-progress-bar', FreeShippingProgressBar);
